<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.3399 6.85998H3.99991V14.06C3.99991 14.2866 3.92311 14.4768 3.76951 14.6304C3.61591 14.784 3.42604 14.8605 3.19991 14.86C2.97324 14.86 2.78311 14.7832 2.62951 14.6296C2.47591 14.476 2.39937 14.2861 2.39991 14.06V6.85998C2.39991 6.41998 2.5567 6.04318 2.8703 5.72958C3.1839 5.41598 3.56044 5.25944 3.99991 5.25998H11.3399L9.03991 2.93998C8.89324 2.79331 8.81644 2.61011 8.80951 2.39038C8.80257 2.17064 8.87937 1.98051 9.03991 1.81998C9.18657 1.67331 9.37324 1.59998 9.59991 1.59998C9.82657 1.59998 10.0132 1.67331 10.1599 1.81998L13.8399 5.49998C13.9999 5.65998 14.0799 5.84664 14.0799 6.05998C14.0799 6.27331 13.9999 6.45998 13.8399 6.61998L10.1599 10.3C9.99991 10.46 9.81324 10.5368 9.59991 10.5304C9.38657 10.524 9.19991 10.4405 9.03991 10.28C8.89324 10.12 8.81644 9.93331 8.80951 9.71998C8.80257 9.50664 8.87937 9.31998 9.03991 9.15998L11.3399 6.85998Z" fill="#FCFCFC"/>
  </svg>
</template>

<script>
export default {
  name: 'connection-icon'
}
</script>

<style scoped>
svg {
  height: 16px;
  width: 15px;
}

path {
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 0 !important;
}
</style>
